// const baseURL = "http://localhost:8008/api";
const baseURL = "https://supermedic.app/api";

export default baseURL;
